import type { InstallAvailability } from '@/platform/types'

/* Spec PWA-001 — FR-031: convite de instalacao dispensavel, sem reexibir por 30 dias. Funcoes puras. */

export const INSTALL_DISMISS_KEY = 'gpd-install-dismissed-at'
export const INSTALL_DISMISS_DAYS = 30

export function isDismissActive(dismissedAt: string | null, now: number): boolean {
    if (!dismissedAt) return false
    const at = Number(dismissedAt)
    if (!Number.isFinite(at)) return false
    return now - at < INSTALL_DISMISS_DAYS * 24 * 60 * 60 * 1000
}

export function shouldShowInstallPrompt(availability: InstallAvailability, dismissedAt: string | null, now: number): boolean {
    if (availability.kind !== 'prompt' && availability.kind !== 'ios-manual') return false
    return !isDismissActive(dismissedAt, now)
}
